import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import { getUser } from 'auth/selectors';
import { exportGeneralVoucher } from 'lib/vouchers';
import EmployeeVoucherSign from 'reports/containers/EmployeeVoucherSign';

export class EmployeesAssetsReportTable extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    count: PropTypes.number.isRequired,
    handleOrderChange: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    company: PropTypes.any,
    subcompany: PropTypes.any,
    permissions: PropTypes.any,
    user: PropTypes.object,
  };

  render = () => {
    const { company, subcompany, permissions, user, t, children } = this.props;
    const headers = [
      {
        variable: 'key',
        text: t('employees.fields.key') + ': ',
        type: 'h3',
      },
      { variable: 'name', text: t('employees.fields.name') + ': ' },
      { variable: 'lastname', text: t('employees.fields.lastname') + ': ' },
      { variable: 'position', text: t('employees.fields.position') + ': ' },
      { variable: 'total', text: t('employees.fields.numberAssignedAssets') + ': ' },
    ];

    const config = {
      actions: t('common.actions'), //Texto de seccion de acciones
      edit: t('common.edit'), //Texto de boton editar
      editPermission: 'acl.assets.update.NoTiene',
      togglePermission: 'acl.assets.toggle.NoTiene',
      editUrl: 'assets', //Url para editar empleado
      propsName: 'record', //de donde se obtienen los props
      company: company,
      subcompany: subcompany,
      gPDF: true,
      // In the client's format, as the desktop row (lib/vouchers exportGeneralVoucher).
      exportPDF: (record) => exportGeneralVoucher(record, { company, subcompany, user }),
      // Phone cards (Common.List): "Firmar y guardar" next to "Exportar PDF".
      cardActions: (record) => (
        <EmployeeVoucherSign record={record} className="btn btn-outline-success btn-sm mx-2" />
      ),
    };

    const dataCard = {
      rows: children,
      headers: headers,
      config: config,
      permissions: permissions,
    };

    return (
      <Common.List dataCard={dataCard}>
        <thead>
          <tr>
            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.key"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('employees.fields.key')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.name"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('employees.fields.name')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.lastname"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('employees.fields.lastname')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.position"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('employees.fields.position')}
            </Common.ThSortable>

            <th className="text-center">{this.props.t('employees.fields.numberAssignedAssets')}</th>

            <th className="text-center">{this.props.t('common.actions')}</th>
          </tr>
        </thead>

        <tbody>
          {this.props.count === 0 && <Common.EmptyTable colSpan={20} />}
          {this.props.children}
        </tbody>
      </Common.List>
    );
  };
}

const mapStateToProps = (state) => ({ user: getUser(state) });

export default connect(mapStateToProps)(translate()(EmployeesAssetsReportTable));



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/employees_assets/EmployeesAssetsReportTable.js